import { shuffle } from 'lodash'

export function customShuffle(array, item) {
  let arrayCopy = [...array]
  let randomItem = shuffle(arrayCopy)[0]
  if (arrayCopy.length === 1) {
    return [randomItem, []]
  }
  if (randomItem === item) {
    arrayCopy.splice(arrayCopy.indexOf(item), 1)
    randomItem = shuffle(arrayCopy)[0]
    arrayCopy.splice(arrayCopy.indexOf(randomItem), 1)
    arrayCopy.push(item)
  } else {
    arrayCopy.splice(arrayCopy.indexOf(randomItem), 1)
  }
  return [randomItem, arrayCopy]
}

export function shuffleWithElement(array, answer) {
  // Shuffle array
  const arrayCopy = [...array]
  arrayCopy.splice(arrayCopy.indexOf(answer), 1)
  const shuffled = shuffle(arrayCopy)
  // Get sub-array of first n elements after shuffled
  let selected = shuffled.slice(0, 4)
  selected.push(answer)
  return shuffle(selected)
}

export function blindShuffle(array) {
  return shuffle(array)
}

export function notRepeatingShuffle(array) {
  let shuffled = shuffle(array)
  while (true) {
    if (shuffled[0].OptionValue !== array[0].OptionValue) {
      break
    } else {
      shuffled = shuffle(array)
    }
  }
  return shuffled
}

export function notRepeatingShuffleForRank(array) {
  let shuffled = shuffle(array)
  while (true) {
    // ...

    if (shuffled.length === 2) {
      if (
        shuffled[0].Option !== array[0].Option &&
        shuffled[1].Option !== array[1].Option
      ) {
        break
      } else {
        shuffled = shuffle(array)
      }
    } else if (shuffled.length === 3) {
      if (
        shuffled[0].Option !== array[0].Option &&
        shuffled[1].Option !== array[1].Option &&
        shuffled[2].Option !== array[2].Option
      ) {
        break
      } else {
        shuffled = shuffle(array)
      }
    } else if (shuffled.length === 4) {
      if (
        shuffled[0].Option !== array[0].Option &&
        shuffled[1].Option !== array[1].Option &&
        shuffled[2].Option !== array[2].Option &&
        shuffled[3].Option !== array[3].Option
      ) {
        break
      } else {
        shuffled = shuffle(array)
      }
    } else {
      if (
        shuffled[0].Option !== array[0].Option &&
        shuffled[1].Option !== array[1].Option &&
        shuffled[2].Option !== array[2].Option &&
        shuffled[3].Option !== array[3].Option &&
        shuffled[4].Option !== array[4].Option
      ) {
        break
      } else {
        shuffled = shuffle(array)
      }
    }
  }
  return shuffled
}
